import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";

import "./EventDetailHero.scss";
import { ImgStore } from '../../../../elements/ImgStore/ImgStore';
import { LocaleFlag } from '../../../../frames/Locales/LocaleFlag/LocaleFlag';
import { EventDate } from '../../parts/EventDate/EventDate';
import { EventSignAction } from '../../parts/EventSignAction/EventSignAction';

export const EventDetailHero = (props)=>{
    const { event, detail } = props;
    const place = event.gameSpace?.name || event.gameSpace?.address;

    return (
        <Block tagName="section" className="EventDetailHero wall -dark -border">
            <div className="visual">
                <ImgStore src={event.webImg ?? "eventImgDefault"}/>
            </div>
            <div className="content">
                <header className="header">
                    <p className="eyebrow">{detail.labels.eventKind}</p>
                    <div className="status">
                        <strong className={detail.isOpen ? "positive" : ""}>{detail.statusLabel}</strong>
                        <span>{detail.accessLabel}</span>
                    </div>
                </header>
                <section className="body">
                    <div className="title">{detail.title}</div>
                    <ul className="infoPanel">
                        {event.startAtEst && <li className="date"><EventOutlinedIcon/><EventDate value={event.startAtEst} row={event}/></li>}
                        {place && <li className="place"><PlaceOutlinedIcon/><span>{place}</span></li>}
                        <li className="record"><DvrOutlinedIcon/><span>{detail.recordLabel}</span></li>
                        {detail.localeLabel && <li className="locale"><TranslateOutlinedIcon/><span>{detail.localeLabel}</span><LocaleFlag locale={event.locale}/></li>}
                    </ul>
                </section>
                <footer className="footer">
                    <EventSignAction eventId={event.id}/>
                </footer>
            </div>
        </Block>
    )
}
